import AudioPlayer from 'components/AudioPlayer/AudioPlayer';
import { useAuth } from 'contexts/AuthContext';
import React from 'react';
import { User } from 'types';

interface ContentPodCastProps {
    id: string;
    audioUrl: string;
    thumbnail: string;
    title: string;
    description: string;
    duration: string;
    toggleLessonCompletion: (user: User, id: string) => void;
    isContentCompleted: (user: User, id: string) => boolean;
}

const ContentPodCast: React.FC<ContentPodCastProps> = ({id, audioUrl, thumbnail, title, description,isContentCompleted }) => {
  const { user } = useAuth();

  if (!user) return null;

  const completed = isContentCompleted(user, id);

  return (
    <>
      {/* Podcast Player */}
      <AudioPlayer trackUrl={audioUrl} />
      
      {/* Podcast Info */}
      <div className="mt-4 bg-white rounded-xl p-6 shadow-sm">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              {title}
            </h2>
            <p className="text-gray-600">
              {description || 'Uma jornada sonora pelos caminhos do feminino selvagem.'}
            </p>
          </div>
          {/* <button
            onClick={() => toggleLessonCompletion(user, id)}
            className={`ml-4 px-4 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${
              completed
                ? 'bg-green-100 text-green-700 hover:bg-green-200'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {completed ? (
              <>
                <span>✓</span>
                <span>Concluída</span>
              </>
            ) : (
              <>
                <span>○</span>
                <span>Marcar como concluída</span>
              </>
            )}
          </button> */}
        </div>
      </div>
    </>
  );
};

export default ContentPodCast;